import { ActionReference, GameObjectReference, GameState } from "@shared/types";
import { LitElement, TemplateResult, css, html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import {
    getState,
    performAction,
    setChestFraseInput,
    setPlayerNameInSession,
    setVaultCodeInputs
} from "../services/routeService";
// import {PlayerSession} from "@adventure-game/api/src/types";
// import {getPlayerSession} from "@adventure-game/api/src/instances";
// import { setPlayerNameInLocalStorage} from "../helpers";

@customElement("game-canvas")
export class GameCanvas extends LitElement {
    public static styles = css`
        .game {
            height: 100%;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: auto auto 1fr auto;
            grid-column-gap: 0px;
            grid-row-gap: 0px;
        }

        .title {
            display: flex;
            flex-direction: column;
            align-items: center;
            
            p{
                margin-bottom: 0;
                margin-top: 10px;
            }
        }

        .header {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 1;
            position: relative;
            margin-top: 10px;
        }

        .header img {
            width: 100%;
            height: auto;
            image-rendering: pixelated;
            max-height:600px;
        }
        
        .header img:nth-child(n + 2) {
            position: absolute;
        }

        .colosseum-header {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex-grow: 1;
            position: relative;
            margin-top: 10px;
        }

        .colosseum-header img {
            width: 100%;
            height: auto;
            image-rendering: pixelated;
            max-height: 340px;
        }


        .colosseum-header img:nth-child(n + 2) {
            position: absolute;
        }

        .content {
            flex-grow: 1;
            overflow: auto;
            margin-top: 10px;
            padding: 0 10px;
        }

        .content p {
            margin: 0 0 10px 0;
        }

        .content p:last-of-type {
            margin: 0;
        }

        .footer {
            border-radius: 10px 10px 0 0;
            background-color: white;
            border: 1px solid #332c57;
            margin-top: 10px;
            display: flex;
            height: 150px;
        }

        .footer .buttons {
            display: flex;
            flex-direction: column;
            overflow: auto;
            padding: 10px 10px 0 10px;
        }

        .hidden {
            display: none;
        }

        .inventory {
            color: black;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: #ffffff;
            border: 2px solid #000000;
            border-radius: 10px;
            padding: 20px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            z-index: 1000;
        }

        .footer .button {
            background-color: black;
            padding: 5px 10px;
            margin: 0 0 10px 10px;
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            user-select: none;
        }

        .footer .btnObject{
            background-color: #7f6ed7;
        }

        .footer .button.active,
        .footer .button:hover {
            background-color: lightgray;
        }
        .Code-Input-Container {
            width:100%;
            height: auto;
            display:flex;
            justify-content:center;
            flex-direction:row;
            align-items:center;
            overflow:hidden;
            
            input{
                
                    width: 30px; 
                    height: 30px; 
                    text-align: center; 
                    font-size: 24px; 
                    margin-left: 40px;
                    margin-right: 40px;
                    
            }
        }

        .name-input-container{
            width:100%;
            height:100px;
            display:flex;
            justify-content:center;
            flex-direction:column;
            align-items:center;

            input{
                width:200px;
                height:35px;
                display:flex;
            }
        }

        .chest-frase-input-container{
            width:100%;
            height:50px;
            display:flex;
            justify-content:center;
            flex-direction:column;
            align-items:center;

            input{
                width:200px;
                height:35px;
                display:flex;
            }
        }
    `;


    private roomTitle?: string;
    private roomObjective?: string;
    private roomAlias?: string;
    private roomImages?: string[];
    private contentText?: string[];
    private actionButtons?: ActionReference[];
    private gameObjectButtons?: GameObjectReference[];
    private inventory?: GameObjectReference[];
    private examinedChest?: boolean;
    private progression?: number;

    private showInvertory: boolean = false;

    private selectedActionButton?: ActionReference;
    private selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();

    private inputNameErrorMessage: boolean = false;

    public connectedCallback(): void {
        super.connectedCallback();

        window.addEventListener("keydown", (e) => {
            if (e.key === "f") {
                this.showInvertory = !this.showInvertory;
                this.requestUpdate();
            }
        });
        void this.refreshState();
    }

    private async refreshState(): Promise<void> {
        const state: GameState = await getState();

        this.updateState(state);
    }

    private updateState(state: GameState): void {
        //Reset the component
        this.roomTitle = state.roomTitle;
        this.roomAlias = state.roomAlias;
        this.roomObjective = state.roomObjective;
        this.roomImages = state.roomImages;
        this.contentText = state.text;
        this.actionButtons = state.actions;
        this.gameObjectButtons = state.objects;
        this.inventory = state.inventory;
        this.examinedChest = state.examinedChest;
        this.progression = state.progression;

        this.selectedActionButton = undefined;
        this.selectedGameObjectButtons.clear();

        this.requestUpdate();
    }


    private async handleClickAction(button: ActionReference): Promise<void> {
        if (button.needsObject) {

            this.selectedActionButton = button;
            this.selectedGameObjectButtons.clear();

            if (button.alias === "Open-action") {

                const CodeInputLeft: HTMLInputElement | null = this.shadowRoot?.getElementById("code-input-left") as HTMLInputElement;
                const CodeInputMiddle: HTMLInputElement | null = this.shadowRoot?.getElementById("code-input-middle") as HTMLInputElement;
                const CodeInputRight: HTMLInputElement | null = this.shadowRoot?.getElementById("code-input-right") as HTMLInputElement;

                if (CodeInputLeft && CodeInputMiddle && CodeInputRight) {
                    const codeArray: string = `${CodeInputLeft.value}${CodeInputMiddle.value}${CodeInputRight.value}`;

                    await setVaultCodeInputs(codeArray);
                }
            }

            if (button.alias === "open-chest-action") {

                const fraseInput: HTMLInputElement | null = this.shadowRoot?.getElementById("chest-frase-input") as HTMLInputElement;

                if (fraseInput) {
                    const chestFrase: string = `${fraseInput.value}`;

                    await setChestFraseInput(chestFrase);
                }
            }

            this.requestUpdate();
        } else {

            if (button.alias === "confirm-name") {

                const nameInput: HTMLInputElement | null = this.shadowRoot?.querySelector("#name-input") as HTMLInputElement;

                if (nameInput.value) {
                    await setPlayerNameInSession(nameInput.value);
                } else {
                    this.inputNameErrorMessage = true;
                    this.requestUpdate();
                    return;
                }
            }

            const state: any = await performAction(button.alias);

            if (state === undefined) {
                return;
            }

            this.updateState(state);
        }
    }


    private async handleClickObject(button: GameObjectReference): Promise<void> {
        if (!this.selectedActionButton) {
            return;
        }

        this.selectedGameObjectButtons.add(button);

        const state: GameState | undefined = await performAction(
            this.selectedActionButton.alias,
            [...this.selectedGameObjectButtons].map((e) => e.alias)
        );

        if (this.selectedGameObjectButtons.size >= 2) {
            this.selectedActionButton = undefined;
            this.selectedGameObjectButtons.clear();
        }

        this.requestUpdate();

        if (state === undefined) {
            return;
        }

        this.updateState(state);
    }


    protected render(): TemplateResult {
        return html`
            <div class="game">
                ${this.renderTitle()}  ${this.renderNameInputContent()} ${this.renderHeader()} ${this.renderInvertory()} ${this.renderVaultCodeInput()} ${this.renderChestFraseInput()} ${this.renderContent()} ${this.renderFooter()}
            </div>
        `;
    }

    private renderTitle(): TemplateResult {
        if(this.roomTitle &&
            this.roomAlias === "startup" || 
            this.roomAlias === "intro-story-room" || 
            this.roomAlias === "about-room" ||
            this.roomAlias === "enter-your-name-room" ||
            this.roomAlias === "credit-room"
            ){
                return html`<div class="title">
                <p>${this.roomTitle}</p>
                <p>${this.roomObjective}</p>
            </div>`;
        }
        
        if (this.roomTitle) {
            return html`<div class="title">
                <p>${this.roomTitle}</p>
                <p>${this.roomObjective} ${this.progression}/3</p>
                <p>Press F for inventory</p>
            </div>`;
        }
        
        return html`${nothing}`;
    }

    private renderHeader(): TemplateResult {
        if (this.roomImages && this.roomImages.length > 0) {
            if (this.roomAlias?.includes("colosseum")) {
                return html`
                <div class="colosseum-header">
                    ${this.roomImages?.map((url) => html`<img src="/assets/img/rooms/${url}.png" />`)}
                </div>
            `;
            }

            return html`
                <div class="header">
                    ${this.roomImages?.map((url) => html`<img src="/assets/img/rooms/${url}.png" />`)}
                </div>
            `;
        }
        return html`${nothing}`;
    }

    private renderContent(): TemplateResult {
        return html`<div class="content">${this.contentText?.map((text) => html`<p>${text}</p>`)}</div>`;
    }

    private renderNameInputContent(): TemplateResult {
        if (this.roomAlias === "enter-your-name-room") {
            return html`
            <div class="name-input-container">
                <input id="name-input" type="text" placeholder="your name"/>
                ${this.inputNameErrorMessage ? html`<p>Please enter your name</p>` : null}
            </div>`;
        }
        return html`${nothing}`;
    }

    private renderChestFraseInput(): TemplateResult {

        if (this.roomAlias === "colosseum: Statue Area" && this.examinedChest) {
            return html`
            <div class="chest-frase-input-container">
                <input id="chest-frase-input" type="text"/>
            </div>`;
        }
        return html`${nothing}`;
    }

    private renderFooter(): TemplateResult {
        return html`
            <div class="footer">
                <div class="buttons">
                    <div>
                        ${this.actionButtons?.map((button) => html`
                        <a class="button ${this.selectedActionButton === button ? "active" : ""}" @click=${(): void => void this.handleClickAction(button)}>${button.label}</a>
                        `
                         )}
                    </div>

                    <div>
                        ${this.selectedActionButton? this.gameObjectButtons?.map((button) => html`
                        <a class="btnObject button ${this.selectedGameObjectButtons.has(button) ? "active": ""}" @click=${(): void => void this.handleClickObject(button)}>${button.name}</a>
                        `): nothing}
                    </div>

                </div>
            </div>
        `;
    }

    private renderVaultCodeInput(): TemplateResult {
        if (this.roomAlias === "vault-room") {
            return html`
                <div class="Code-Input-Container">
                    <input type="number" max="9" min="0" id="code-input-left" placeholder="0">
                    <input type="number" max="9" min="0" id="code-input-middle" placeholder="0">
                    <input type="number" max="9" min="0" id="code-input-right" placeholder="0">
                </div>
                    `;
        }

        return html`${nothing}`;
    }

    private renderInvertory(): TemplateResult {
        if (this.roomAlias !== "startup" &&
            this.roomAlias !== "intro-story-room" &&
            this.roomAlias !== "about-room" &&
            this.roomAlias !== "enter-your-name-room") {

            return html`
            <div class=${this.showInvertory ? "inventory" : "hidden"}>
                <p>invertory:</p>
                ${this.inventory?.map((object) => html`<p>${object.name}</p>`)}
            </div>
            `;
        }
        return html`${nothing}`;

    }
}

